type ThreadLike = {
  subscription?: { read_at?: string | null } | null;
  latestMessage?: { created_at: string } | null;
};

export function hasUnread(thread: ThreadLike): boolean {
  if (!thread.subscription || !thread.latestMessage) {
    return false;
  }

  const readAt = thread.subscription.read_at;

  if (!readAt) {
    return true;
  }

  return (
    new Date(readAt).getTime() <
    new Date(thread.latestMessage.created_at).getTime()
  );
}
